export function getFilterTranslations(t) {
  return {
    client: t('Client'),
    shopcity: t('City'),
    username: t('Team'),
    shopcountry: t('Country'),
    sector: t('Sector'),
    shopname: t('Shop name'),
    shop_code: t('Store code'),
    shopprovince: t('Province'),
    shopsign: t('Shop sign'),
    project: t('Program'),
    shopzipcode: t('Zip code'),
    item: t('Item'),
    product: t('Product'),
    product_item: t('Product (item)'),
    product_ai: t('Product (AI)'),
    latest_visit: t('Latest visit per store'),
    favorite: t('Favorites'),
    deleted: t('Deleted photos'),
    translatedquestion: t('Question'),
    visittype: t('Visit type'),
    campaign: t('Campaign'),
    source: t('Source'),
  };
}
